// src/components/contact/ContactFormSection/ContactFormSection.jsx
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FaPaperPlane } from 'react-icons/fa';
import axios from 'axios';
import Button from '../../../components/general/button/Button';
import MyContext from '../../../context/MyContext';
import '../../../assets/css/customer/contact/contactForm/Contactform.css';

const ContactForm = () => {
  const { baseUrl } = useContext(MyContext);

  // ── Alag-alag states, koi ek "formData" object nahi ──
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const [formStatus, setFormStatus] = useState({ type: '', message: '' });
  const [isVisible, setIsVisible] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px'
      }
    );

    if (formRef.current) {
      observer.observe(formRef.current);
    }

    return () => {
      if (formRef.current) {
        observer.unobserve(formRef.current);
      }
    };
  }, []);

  // ════════════════════════════════
  // API: submitMessage
  // Public endpoint hai — login ho ya na ho, koi bhi bhej sakta
  // hai. Isi liye email diya jata hai (reply email pe milega).
  // ════════════════════════════════
  const submitMessage = () => {
    setSubmitting(true);
    const fd = new FormData();
    fd.append('name', name);
    fd.append('email', email);
    fd.append('phone', phone);
    fd.append('subject', subject);
    fd.append('message', message);

    axios
      .post(`${baseUrl}/customer/contact/submitMessage`, fd)
      .then(({ data }) => {
        setSubmitting(false);
        if (data.success) {
          setFormStatus({ type: 'success', message: data.message });
          setTimeout(() => {
            setName('');
            setEmail('');
            setPhone('');
            setSubject('');
            setMessage('');
            setFormStatus({ type: '', message: '' });
          }, 3000);
        } else {
          setFormStatus({ type: 'error', message: data.message || 'Failed to send message.' });
        }
      })
      .catch(() => {
        setSubmitting(false);
        setFormStatus({ type: 'error', message: 'Failed to send message. Please try again.' });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !email || !subject || !message) {
      setFormStatus({ type: 'error', message: 'Please fill all required fields.' });
      return;
    }

    submitMessage();
  };

  return (
    <div 
      ref={formRef}
      className={`form-wrapper ${isVisible ? 'animate-in' : ''}`}
    >
      <div className="form-header">
        <h2 className="form-title">Send us a Message</h2>
        <p className="form-subtitle">
          Fill out the form below and we'll get back to you within 24 hours.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="contact-form">
        <Row className="g-3">
          <Col xs={12} md={6}>
            <div className="contactform-group">
              <input
                type="text"
                name="name"
                className="form-input"
                placeholder="Your Name *"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </Col>
          
          <Col xs={12} md={6}>
            <div className="contactform-group">
              <input
                type="email"
                name="email"
                className="form-input"
                placeholder="Your Email *"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </Col>
          
          <Col xs={12} md={6}>
            <div className="contactform-group">
              <input
                type="tel"
                name="phone"
                className="form-input"
                placeholder="Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          </Col>
          
          <Col xs={12} md={6}>
            <div className="contactform-group">
              <input
                type="text"
                name="subject"
                className="form-input"
                placeholder="Subject *"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>
          </Col>
          
          <Col xs={12}>
            <div className="contactform-group">
              <textarea
                name="message"
                className="form-input form-textarea"
                placeholder="Your Message *"
                rows="6"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
            </div>
          </Col>
          
          <Col xs={12}>
            {formStatus.message && (
              <div className={`form-status ${formStatus.type}`}>
                {formStatus.message}
              </div>
            )}
            <Button 
              type="submit" 
              variant="gradient" 
              icon={<FaPaperPlane />}
              fullWidth
              disabled={submitting}
            >
              {submitting ? 'Sending...' : 'Send Message'}
            </Button>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default ContactForm;
